@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="isOem()" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-system-inputs (valueChanged)="validateAndRateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()" [showCoilWarningMessage]=true
        (unitTypeChanged)="unitTypeChanged()" (systemTypeChanged)="systemTypeChanged()">
      </app-system-inputs>
      <app-indoor-air-quality (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-indoor-air-quality>
      <app-direct-drive-performance-input (valueChanged)="validateAndRateUnit()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-input>
      <app-direct-drive-performance-results [selectionEntities]="selectionEntities()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-results>
      <app-mega-mod-mechanical-connections [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" [imagePrefix]="getImagePrefix()"
        (valueChanged)="validateUnit()">
      </app-mega-mod-mechanical-connections>
      <app-modular-controls [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-controls>
      <app-mega-mod-coil-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mega-mod-coil-options>
      <app-modular-primary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-primary-valve-package>
      <app-modular-secondary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-modular-secondary-valve-package>
      <app-mega-mod-cabinet-features [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mega-mod-cabinet-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
